import React from 'react';
import { Dropdown } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
export const EntityReferenceDropdown = _ref => {
  let {
    options,
    selectedItem,
    onChange,
    isDisabled,
    dataId,
    styles,
    dropdownRef
  } = _ref;
  const mapEntityReferenceToDropdownOption = ref => ({
    key: ref.Id,
    text: ref.Name
  });
  const mapDropdownOptionToEntityReference = option => ({
    Id: option.key.toString(),
    Name: option.text
  });
  const handleChange = (_ev, opt) => opt && onChange(mapDropdownOptionToEntityReference(opt));
  const selectedKey = selectedItem && mapEntityReferenceToDropdownOption(selectedItem).key;
  return /*#__PURE__*/_jsx(Dropdown, {
    styles: styles,
    options: options.map(mapEntityReferenceToDropdownOption),
    selectedKey: selectedKey,
    onChange: handleChange,
    disabled: isDisabled,
    dataId: dataId,
    componentRef: dropdownRef
  });
};